import React from 'react';
import styles from './PasswordRequirements.module.css';
import { evaluatePassword, PasswordCriteria } from '../utils/passwordCriteria';

interface PasswordRequirementsProps {
  password: string;
}

const REQUIREMENTS: { key: keyof PasswordCriteria; label: string }[] = [
  { key: 'minLength', label: 'Mínimo 8 caracteres' },
  { key: 'hasUppercase', label: 'Al menos una mayúscula' },
  { key: 'hasLowercase', label: 'Al menos una minúscula' },
  { key: 'hasNumber', label: 'Al menos un número' },
  { key: 'hasSpecialChar', label: 'Al menos un símbolo especial (!@#$%^&*...)' },
];

export default function PasswordRequirements({ password }: PasswordRequirementsProps) {
  const criteria = evaluatePassword(password);

  return (
    <ul className={styles.list}>
      {REQUIREMENTS.map((req) => {
        const met = criteria[req.key];
        return (
          <li key={req.key} className={met ? styles.met : styles.unmet}>
            <span className={styles.icon}>{met ? '✓' : '✗'}</span>
            {req.label}
          </li>
        );
      })}
    </ul>
  );
}
